import styled from 'styled-components'

export const DetailActionsWrapper = styled.div`
  cursor: pointer;
  user-select: none;
  position: relative;
  height: 25px;
  width: 25px;
  z-index: 999;

  :hover,
  :active,
  :focus {
    .detail-actions-buttons {
      display: block;
    }
  }

  .detail-action-open {
    font-weight: bold;
    font-size: 1.2rem;
    border: solid 1px ${({ theme }) => theme.text1};

    :before {
      content: '...';
      width: 25px;
      height: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: rotate(90deg);
      padding: 0 5px;
    }
  }

  .detail-actions-buttons {
    display: none;
    position: absolute;
    left: -125px;
    width: 150px;
    height: 65px;
    background-color: ${({ theme }) => theme.bg3};

    ul {
      padding: 0;
      margin: 0;
      list-style: none;

      li {
        :hover {
          background-color: ${({ theme }) => theme.bg7};
        }
      }

      span {
        display: block;
        padding: 5px 10px;
      }

      a {
        text-decoration: none;
        color: ${({ theme }) => theme.text1};
        width: 100%;
        display: block;
        padding: 5px 10px;

        :hover {
          text-decoration: none;
          color: ${({ theme }) => theme.text1};
        }
      }
    }
  }
`
